// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__JKxo6","titleValueContainer":"styles_titleValueContainer__3FD6E","title":"styles_title__2Gd4a","value":"styles_value__3y_Ei"};